import { FormikHelpers, FormikValues } from 'formik';
import { DateTime } from 'luxon';
import React, { useState } from 'react';
import { number, object } from 'yup';

import Botao from 'Component/Botao';
import Buscando from 'Component/Buscando';
import Cabecalho from 'Component/Cabecalho';
import Form, { Selecao } from 'Component/Form';
import LayoutDefault from 'Component/Layout';
import { RelogioDePontoUploadLista } from 'Component/RelogioDePonto';
import { ANOS, MESES } from 'View/constants';
import { useRecuperarVinculosEmpregaticiosQuery } from 'View/Service/Default/VinculosEmpregaticios';

const regras = object({
  mes: number().required('Obrigatório'),
  ano: number().required('Obrigatório'),
});

const Default = (): React.ReactElement => {
  const [mes, setMes] = useState<number>();
  const [ano, setAno] = useState<number>();

  const {
    data: { vinculos } = {},
    isFetching,
    isLoading,
  } = useRecuperarVinculosEmpregaticiosQuery(
    {
      contain: ['Usuarios', 'Empresas'],
      limit: 200,
      options: { status: 1, bate_ponto: 1 },
    },
    {
      skip: !mes || !ano,
    }
  );

  const filtrar = (
    dados: { mes: number; ano: number },
    form: FormikHelpers<FormikValues>
  ) => {
    setMes(dados.mes);
    setAno(dados.ano);

    form.setSubmitting(false);
  };

  return (
    <LayoutDefault>
      <Cabecalho
        titulo="Upload de relógios de ponto em lote"
        descricao="Importe em lote os relógios de ponto dos funcionários"
      />
      <Form
        emLinha
        onSubmit={filtrar}
        regras={regras}
        desabilitado={isFetching}
      >
        <div className="row justify-content-center">
          <div className="col-md-6 mb-3">
            <div className="hstack gap-3">
              <Selecao
                name="mes"
                inicial={DateTime.now().month}
                opcoes={MESES}
              />
              <Selecao name="ano" inicial={DateTime.now().year} opcoes={ANOS} />
              <Botao type="submit" icone="filter" />
            </div>
          </div>
        </div>
      </Form>
      <Buscando exibir={isLoading} />
      <React.Fragment>
        {mes && ano && (
          <div className="bg-white shadow-sm rounded">
            {vinculos?.map((relogio) => (
              <RelogioDePontoUploadLista
                key={`${relogio.id}-${relogio.modificado}`}
                dados={relogio}
                mes={mes}
                ano={ano}
              />
            ))}
          </div>
        )}
      </React.Fragment>
    </LayoutDefault>
  );
};

export default Default;
